import { render, staticRenderFns } from "./PreCheckoutSidebarRegister.vue?vue&type=template&id=72d10fa8&scoped=true"
import script from "./PreCheckoutSidebarRegister.vue?vue&type=script&lang=js"
export * from "./PreCheckoutSidebarRegister.vue?vue&type=script&lang=js"
import style0 from "./PreCheckoutSidebarRegister.vue?vue&type=style&index=0&id=72d10fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d10fa8",
  null
  
)

export default component.exports